import type { Styles } from '@adornis/ass/style.js';
import { XBasicCard } from '@adornis/chemistry/elements/components/x-card.js';
import { customElement } from 'lit/decorators.js';
/**
 * @customElement cr-card
 */
@customElement('cr-card')
export class ChromiumCard extends XBasicCard {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        padding: this.spacing.sm,
        borderRadius: '15px',
        backgroundColor: 'white',
        '&[href]': { cursor: 'pointer' },
      },
    ];
  }
}
